
const validate = (props) => {
    const errors = {}
    if (!props.email) {
        errors.email = {
            ar: 'يرجى ادخال البريد الالكتروني',
            en: 'Enter your email'
        }
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.email)) {
        errors.email = {
            ar: 'البريد الالكتروني غير صحيح',
            en: 'invalid email'
        }
    }
    if (!props.password) {
        errors.password = {
            ar: ' يرجى ادخال كلمة المرور',
            en: 'Enter your password'
        }
    } 

    return errors
}

export default validate;